import React, { useMemo } from "react";
import { Box } from "@chakra-ui/react";
import GenericSettings from "./GenericSettings";
import { cqAPI } from "../../lib/Auth";

export const REMINDER_EXCLUDED_OPERATORIES = "reminder_excluded_operatories";

/**
 * SS-4386: this location's operatories as the picker's options, valued by the PMS operatory id
 * the appointments carry.
 */
export const operatoryOptions = (operatories) =>
  (Array.isArray(operatories) ? operatories : []).map(({ id, name }) => ({
    value: String(id),
    label: name || `Operatory ${id}`,
  }));

const loadOperatoryOptions = () =>
  cqAPI.get("/settings/campaigns/operatories").then((res) => {
    if (!Array.isArray(res?.data)) throw new Error("The operatories could not be loaded.");
    return operatoryOptions(res.data);
  });

const reminderSection = {
  title: "Appointment reminders: excluded operatories",
  description:
    "Appointments in these operatories get no reminder from a reminder that has \"Do not send reminders for " +
    "appointments in the excluded operatories\" turned on; it applies only to those reminders. This list is " +
    "separate from the excluded operatories in Online Booking.",
  inputs: [
    {
      type: "select",
      isMulti: true,
      id: REMINDER_EXCLUDED_OPERATORIES,
      name: "",
      options: [],
      loadOptions: loadOperatoryOptions,
      // a stored id that is no longer one of the location's operatories stays visible, so it can be removed
      unknownOptionLabel: (id) => `Unknown operatory ${id}`,
    },
  ],
};

/** Outreach settings: the sections it is given, then the appointment reminders' excluded operatories. */
const OutreachSettings = ({ configuration }) => {
  const withReminders = useMemo(() => [...configuration, reminderSection], [configuration]);

  return (
    <Box p={4} overflowY="auto" maxHeight="100vh" width="100%" position="relative">
      <GenericSettings configuration={withReminders} endpoint={"/settings/campaigns"} />
    </Box>
  );
};

export default OutreachSettings;
